import {
  Heading,
  Box,
  Text,
  Flex,
  Wrap,
  WrapItem,
  Image,
  NextImage,
  CarouselDeprecated as Carousel,
  CarouselSlide,
  DSSAnalyticsEvents,
  DssAnalyticsContext,
} from '@dapperlabs/core-fe';
import React from 'react';
import { ABOUT_PAGE_EVENT_NAMES } from 'src/general/constants/enums';

import { SectionProps } from '../models';
import SectionContainer from '../SectionContainer';

interface Props extends SectionProps {
  imageList: any[];
  sectionSubHeading: string;
  trackHandler?: ({
    item_label,
    event_name,
  }: {
    event_name: string;
    item_label: string;
  }) => void;
}

export const AboutLaligaMoments: React.FC<Props> = ({
  sectionHeading,
  sectionSubHeading,
  cards,
  imageList,
  trackHandler,
}) => {
  const carouselEvents: DSSAnalyticsEvents = {
    CAROUSEL_ITEM_CLICK: ABOUT_PAGE_EVENT_NAMES.ABOUT_CAROUSEL_ITEM_CLICK,
  };

  return (
    <SectionContainer>
      <DssAnalyticsContext.Provider
        value={{ events: carouselEvents, trackHandler }}
      >
        <Flex justify='center' gap='5rem'>
          <Box flexBasis={628} display={['none', 'none', 'none', 'block']}>
            <Carousel carouselId='desktop-about-carousel' showNav>
              {imageList.map(({ fields }) => (
                <CarouselSlide
                  key={fields.file.url}
                  previewSrc={fields.file.url}
                >
                  <NextImage width={568} height={460} src={fields.file.url} />
                </CarouselSlide>
              ))}
            </Carousel>
          </Box>
          <Box flexBasis={528}>
            <Heading fontFamily='heading'>{sectionHeading}</Heading>
            <Text>{sectionSubHeading}</Text>
            <Box display={['block', 'block', 'block', 'none']}>
              <Carousel carouselId='mobile-about-carousel' showNav>
                {imageList.map(({ fields }) => (
                  <CarouselSlide
                    key={fields.file.url}
                    previewSrc={fields.file.url}
                  >
                    <NextImage width={568} height={460} src={fields.file.url} />
                  </CarouselSlide>
                ))}
              </Carousel>
            </Box>
            <Wrap justify='center' mt={6} spacing='2rem'>
              {cards.map(({ fields }) => (
                <WrapItem
                  key={fields.cardHeading}
                  alignItems='center'
                  flexBasis={['40%', '40%', '40%', '35%', 200]}
                >
                  <Image
                    boxSize={['44px', '44px', '77px']}
                    alt='icon'
                    src={fields.cardImage.fields.file.url}
                  />
                  <Text ml={4} fontSize='18px' textTransform='capitalize'>
                    {fields.cardHeading}
                  </Text>
                </WrapItem>
              ))}
            </Wrap>
          </Box>
        </Flex>
      </DssAnalyticsContext.Provider>
    </SectionContainer>
  );
};
